// Meta Pixel event helper — safe no-op until the pixel script loads.
export const track = (event, params = {}) => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", event, params);
  }
};
